export default __webpack_public_path__ + "static/media/getFetch.582d29c4.cjs";